import React, {FC, useEffect, useRef, useState} from 'react'
import TextField from "@material-ui/core/TextField";
import {useTranslation} from 'react-i18next'
import { Checkbox } from '@material-ui/core'
import {observer} from 'mobx-react'
import Grow from 'ui/Grow'
import useStore from '../../store';
import {Row, Space} from '../../ui'
import { EmergencyManagerFormState } from './CommunitySettingsModal'
import DeleteModuleButton from './DeleteModuleButton'
import {ConfirmButtonSm, DialogHeaderText, ModalText, ModalRow, ButtonGroup, ToggleGroup, ToggleRow} from './styles'

interface EmergencyManagerProps {
  onEmergencyManagerSave: () => void
  // Only the cleanup - DeleteModuleButton owns the confirm and the delete.
  onEmergencyManagerDeleted: () => void
  emergencyManagerModule?: any
  currentOrgId: number | undefined
  isEmergencyManagerFormChanged: boolean
  emergencyManagerFormState: EmergencyManagerFormState
  onEmergencyManagerToggleDirectorPermission: (e: boolean) => void
}

const EmergencyManagerSection: FC<EmergencyManagerProps> = ({
 onEmergencyManagerSave,
 onEmergencyManagerDeleted,
 emergencyManagerModule,
 currentOrgId,
 onEmergencyManagerToggleDirectorPermission,
 isEmergencyManagerFormChanged,
 emergencyManagerFormState,
}) => {
  const {t} = useTranslation('communitySettings')
  const { t: t2 } = useTranslation('budget')

  const { modulesStore } = useStore()
  
 return (
    <>
     <ModalRow>
       <DialogHeaderText>{t2`emergency_manager`}</DialogHeaderText>
       <ButtonGroup>
         <DeleteModuleButton
            module={emergencyManagerModule}
            moduleLabel={t2`emergency_manager`}
            currentOrgId={currentOrgId}
            onDeleted={onEmergencyManagerDeleted}
         />
          <ConfirmButtonSm
            disabled={!isEmergencyManagerFormChanged}
            onClick={onEmergencyManagerSave}>
            {t`budget:save`}
          </ConfirmButtonSm>
       </ButtonGroup>
     </ModalRow>
      
      <ToggleGroup>
        <ToggleRow>
          <ModalText>{t2`allow_director_to_manage`}:</ModalText>
          <Checkbox
            checked={emergencyManagerFormState.directorPermission}
            onChange={(e) => {
              onEmergencyManagerToggleDirectorPermission(e.target.checked)
            }}
          />
        </ToggleRow>
      </ToggleGroup>
      <Space/>
    </>
  )
}

export default observer(EmergencyManagerSection)
